import axios from "@/crm-axios";

// crm-api 발송 경로 관리 API (SPEC-MSGD-004 plan §4-1, CERTILIFE 전용).
// 관리 API 라 대상 병원 헤더가 필요 없다 — 회사는 주소의 companyId 로 정한다.
// route 는 저장값 inapi | dispatcher, channel 은 alimtalk | sms | brandmessage.
const BASE_URL = "/admin/message-routes";

export const messageRouteApi = {
  // { defaults[3], overrides[], dispatcherConfigured, propagationSeconds }
  list() {
    return axios.get(BASE_URL);
  },

  // 고객사 전체 일괄 적용 = 전체 기본값 바꾸기 (회사 개별 설정은 그대로)
  setDefault(channel, route) {
    return axios.put(`${BASE_URL}/default/${channel}`, { route });
  },

  // companyName 은 crm 이 표시용으로만 저장한다(B7)
  setCompany(companyId, channel, route, companyName) {
    return axios.put(`${BASE_URL}/companies/${companyId}/${channel}`, { route, companyName });
  },

  // 기본값 따름 = 회사 개별 행 지우기
  clearCompany(companyId, channel) {
    return axios.delete(`${BASE_URL}/companies/${companyId}/${channel}`);
  },

  // 채널별 개별 설정 모두 지우기 (전체 기본값 행은 남음)
  clearAllCompanies(channel) {
    return axios.delete(`${BASE_URL}/companies`, { params: { channel } });
  },

  // { items[], page, limit, total } — at 내림차순. 빈 거르기 값(undefined)은 axios 가 빼고 보낸다.
  history({ channel, companyId, page, limit }) {
    return axios.get(`${BASE_URL}/history`, { params: { channel, companyId, page, limit } });
  },
};
